import { Cluster } from '@cast/types';
import { CloudVolume } from '@cast/types-stop';

import { NodeWithDependencies } from 'features/cluster/nodes/types';
import { useCloudVolumeCurrentMetricsQuery } from 'hooks/queries/nodes/useCloudVolumeCurrentMetricsQuery';

import { StorageCurrentUsage } from '../_components/StorageCurrentUsage';

type ManagedDiskCurrentUsageProps = {
  node?: NodeWithDependencies;
  cluster: Cluster;
  disk: CloudVolume;
  isCloudDisksEnabled?: boolean;
};

export const ManagedDiskCurrentUsage = ({
  node,
  cluster,
  disk,
  isCloudDisksEnabled,
}: ManagedDiskCurrentUsageProps) => {
  const { currentAvg, isLoading, error, refetch } =
    useCloudVolumeCurrentMetricsQuery({
      clusterId: cluster.id,
      nodeName: node?.name,
      volumeId: disk.volumeId,
    });

  return (
    <StorageCurrentUsage
      iops={currentAvg?.iops}
      provisionedIops={currentAvg?.provisionedIops}
      throughputBytes={currentAvg?.throughputBytes}
      provisionedThroughputBytes={currentAvg?.provisionedThroughputBytes}
      showCapacity={false}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      isCloudDisksEnabled={isCloudDisksEnabled}
    />
  );
};
